import { DocumentTitle } from '@/shared/components/DocumentTitle';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary.tsx';
import { FullscreenLoadingSuspenseBoundary } from '@/shared/components/FullscreenLoadingSuspenseBoundary';
import { BeforeUnloadContextProvider } from '@/shared/context/BeforeUnloadContext';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

export const FulfillmentBaseFrame = ({ children }: PropsWithChildren) => {
    const { t } = useTranslation();
    return (
        <>
            <DocumentTitle title={t('page.fulfillment.documentTitle')} />
            <ErrorBoundary>
                <FullscreenLoadingSuspenseBoundary>
                    <BeforeUnloadContextProvider defaultEnabled>{children}</BeforeUnloadContextProvider>
                </FullscreenLoadingSuspenseBoundary>
            </ErrorBoundary>
        </>
    );
};
